import { useMutation, useQueryClient } from '@tanstack/react-query'
import { assignRequirementToPosition } from 'api/company/position/requirement'
import { positionsKeys } from 'queries/positions'
import { requirementDataForPositionKey } from './keys'

type Response = Awaited<ReturnType<typeof assignRequirementToPosition>>
type Variables = { requirementId: number; mustHave: boolean }

export const useAssignRequirementToPositionMutation = (positionId: number) => {
  const queryClient = useQueryClient()
  return useMutation<Response, Error, Variables>({
    mutationFn: ({ requirementId, mustHave }) =>
      assignRequirementToPosition({
        positionId,
        requirementId,
        mustHave,
      }),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: requirementDataForPositionKey(positionId),
        }),
        queryClient.invalidateQueries({
          queryKey: positionsKeys.detail(positionId),
        }),
      ])
    },
  })
}
